export const calculateCouponDiscount = (item, quantity, couponCodeDiscount) => {
  return Math.round(
    (((item.discount_price || item.price) * couponCodeDiscount.discountValue) / 100) * quantity
  );
};

export const getTotalCouponReduction = (basket, couponCodeDiscount) => {
  if (couponCodeDiscount.discountValue === 0) return 0;

  let totalReduction = 0;
  basket.forEach((item) => {
    if (couponCodeDiscount.applicableProducts.includes(item.id)) {
      totalReduction += calculateCouponDiscount(item, item.quantity, couponCodeDiscount);
    }
  });
  return totalReduction;
};
